<template>
  <div>
    <!-- 保留 v-if="url" 控制 iframe 渲染，确保 url 有效才渲染 -->
    <div v-if="url" style="height: calc(100vh - 50px); overflow-y: scroll; -webkit-overflow-scrolling: touch">
      <iframe 
        style="height: calc(100% - 1.5rem); width: 100%"  
        ref="iframe" 
        scrolling="auto" 
        frameborder="0"  
        id="iframe"
      ></iframe>
    </div>
    <!-- 新增：url 未加载完成时的占位提示 -->
    <div v-else style="height: calc(100vh - 50px); display: flex; align-items: center; justify-content: center; color: #666">
      加载客服链接中...
    </div>
  </div>
</template>

<script>
export default {
  name: 'kefu',
  data() {
    return {
      url: null,
    };
  },
  created() {
    this.getservicerurl(); // 初始化获取客服链接
  },
  methods: {
    // 获取客服链接（核心修复：替换可选链语法，兼容 ES5）
    getservicerurl() {
      let that = this;
      that.$apiFun.post('/api/getservicerurl', {})
        .then(res => {
          if (res.code !== 200) {
            that.showTost(0, res.message || '获取客服链接失败');
            return;
          }
          // 关键修复：用 ES5 兼容写法替代可选链 res.data?.url
          // 等价于：如果 res.data 存在，就取 res.data.url，否则取 undefined
          const dataUrl = res.data ? res.data.url : undefined;
          that.url = res.url || dataUrl; // 兼容 res.url 或 res.data.url 两种格式
          
          // 2. 当 url 赋值后，用 $nextTick 等待 DOM 渲染完成，再操作 iframe
          that.$nextTick(() => {
            that.setIframeUrl();
          });
        })
        .catch(err => {
          console.error('获取客服链接请求失败：', err);
          that.showTost(0, '网络异常，无法加载客服');
        });
    },
    // 封装 iframe 地址设置逻辑（便于复用和容错）
    setIframeUrl() {
      const iframe = this.$refs.iframe;
      // 双重容错：确保 iframe 和 url 有效
      if (iframe && this.url) {
        try {
          // 避免重复设置相同地址（优化性能）
          if (iframe.contentWindow.location.href !== this.url) {
            iframe.contentWindow.location.replace(this.url);
          }
        } catch (e) {
          // 捕获跨域等异常（iframe 跨域可能无法访问 contentWindow）
          console.error('设置 iframe 地址失败：', e);
          // 跨域时直接设置 src 属性（备选方案）
          iframe.src = this.url;
        }
      }
    },
    // 复用 App.vue 中的提示方法（若全局注册可直接用，否则需导入）
    showTost(type, title) {
      let str = type ? 'success' : 'danger';
      this.$notify({ type: str, message: title });
    },
  },
  // 移除原 updated 钩子（无需依赖它，改用 $nextTick 精准控制）
  mounted() {
    // 若页面刷新时 url 已存在（如缓存场景），补充设置 iframe 地址
    if (this.url) {
      this.$nextTick(() => {
        this.setIframeUrl();
      });
    }
  },
};
</script>

<style lang="scss" scoped>
// 样式保持不变
</style>


// WEBPACK FOOTER //
// src/components/mode/kefu.vue